export interface GetChildCollectionRequest {
  collectionId: number
}

export function GetChildCollectionRequestToJSON(
  value: GetChildCollectionRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined
  }
}
